/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import r from '../../../util/Renderer'
import Date from '../../unit/Date'
import { dateToStringDate } from '../../../util/DateString'
import ReservationAction from '../../../action/reservation'
import Dropdown from '../../atoms/input/Dropdown'
import DateRangeField from '../../atoms/input/DateRangeField'
import { BaseLayout, ListViewLayout, LocalAreaLayout } from 'ui-library/dist/external/layouts'
import {
  DataTable,
  DataTableColumn as TD,
  DataTableHeader as TH,
  DataTableRow as TR,
  MdcChip,
  MdcChipSet,
  NavigationDrawer,
  Pagination,
  SearchCheckbox,
  SearchField,
  SearchOption
} from 'ui-library/dist/external/components'
import { DeviceType } from 'ui-library/dist/external/constants'
import ArrowRight from '../../atoms/icon/ArrowRight'
import { Status, NoShow } from '../../parts/Reservation'
import { ReservationDetail } from '../../organisms/reservations'
import { PaymentPaid } from '../../parts/Payment'

function ReservationListView(props) {
  const toolbar = { label: `宿泊予約を検索`, items: props.accountMenu }
  const pagination = props.pagination
  const searchFunction = params => {
    const pagination = props.pagination.merge({ page: params.page, per_page: params.perPage })
    ReservationAction.onSearch(props.search, pagination)
  }
  return (
    <React.Fragment>
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} />
      <BaseLayout>
        <LocalAreaLayout
          left={
            <SearchField
              name="search_keywords"
              value={props.search.search_keywords}
              onChange={e => ReservationAction.onEditSearchCondition(e)}
              onSearch={e => ReservationAction.onSearch(props.search, pagination)}
              searchOptions={[
                <SearchOption
                  key={1}
                  label={'宿泊施設'}
                  field={
                    <Dropdown
                      name="search_hotel_ids"
                      value={props.search.search_hotel_ids}
                      options={props.search.search_hotel_options}
                      isClearable={true}
                      isMulti={true}
                      searchable={true}
                      onChange={e => ReservationAction.onEditSearchCondition(e)}
                    />
                  }
                />,
                <SearchOption
                  key={2}
                  label={'期間'}
                  field={
                    <DateRangeField
                      className="searchDate"
                      startDateName="search_start_date"
                      endDateName="search_end_date"
                      startDate={props.search.search_start_date}
                      endDate={props.search.search_end_date}
                      onChange={e => ReservationAction.onEditSearchCondition(e)}
                    />
                  }
                />,
                <SearchOption
                  key={3}
                  label={'ステータス'}
                  field={
                    <ul>
                      <li>
                        <SearchCheckbox label={'予約済み'} name={'search_status_booked'} checked={props.search.search_status_booked} onChange={e => ReservationAction.onEditSearchCondition(e)} />
                      </li>
                      <li>
                        <SearchCheckbox
                          label={'キャンセル'}
                          name={'search_status_cancelled'}
                          checked={props.search.search_status_cancelled}
                          onChange={e => ReservationAction.onEditSearchCondition(e)}
                        />
                      </li>
                      <li>
                        <SearchCheckbox
                          label={'売り止め'}
                          name={'search_status_not_a_reservation'}
                          checked={props.search.search_status_not_a_reservation}
                          onChange={e => ReservationAction.onEditSearchCondition(e)}
                        />
                      </li>
                    </ul>
                  }
                />,
                <SearchOption
                  key={4}
                  label={'ノーショー'}
                  field={
                    <ul>
                      <li>
                        <SearchCheckbox label={'ノーショーのみ表示'} name={'search_noshow'} checked={props.search.search_noshow} onChange={e => ReservationAction.onEditSearchCondition(e)} />
                      </li>
                    </ul>
                  }
                />,
                <SearchOption
                  key={5}
                  label={'予約サイト'}
                  field={
                    <Dropdown
                      name="search_site_referrer_ids"
                      value={props.search.search_site_referrer_ids}
                      options={props.site_referrer_options}
                      isClearable={true}
                      isMulti={true}
                      searchable={true}
                      onChange={e => ReservationAction.onEditSearchCondition(e)}
                    />
                  }
                />
              ]}
            />
          }
          bottom={ShowSearchCondition(props.search)}
        />

        <ListViewLayout>
          <DataTable
            headers={[
              <TH key={1} width={'80px'}>
                ステータス
              </TH>,
              <TH key={2} widthForPhone={'180px'}>
                宿泊者名
              </TH>,
              <TH key={3} widthForPhone={'180px'}>
                宿泊施設
              </TH>,
              <TH key={4} widthForPhone={'280px'}>
                宿泊予定
              </TH>,
              <TH key={5}>支払い</TH>,
              <TH key={6} showDeviceFor={DeviceType.DESKTOP}>
                予約サイト
              </TH>
            ]}
            rows={[
              r.renderIf(props.reservations)(
                props.reservations.map(reservation => (
                  <TR key={reservation.id} onClick={() => ReservationAction.showDetailView(reservation.id)}>
                    <TD>
                      <Status type={reservation.status}>{reservation.getStatusLabel()}</Status>
                      {r.renderIf(reservation.noshow)(<NoShow>ノーショー</NoShow>)}
                    </TD>
                    <TD>{reservation.name}</TD>
                    <TD>{reservation.stay}</TD>
                    <TD>
                      <Date showYear={false}>{reservation.check_in}</Date>
                      <ArrowRight />
                      <Date showYear={false}>{reservation.check_out}</Date>
                    </TD>
                    <TD>
                      <PaymentPaid paid={reservation.is_paid_accommodation_fee} prefix="[宿泊費] " />
                      <br />
                      <PaymentPaid paid={reservation.is_paid_accommodation_tax} prefix="[宿泊税] " />
                    </TD>
                    <TD showDeviceFor={DeviceType.DESKTOP}>{reservation.site_referer}</TD>
                  </TR>
                ))
              )
            ]}
          />
        </ListViewLayout>
      </BaseLayout>
      {r.renderIf(props.showDetail)(<ReservationDetail page="/reservation">{props}</ReservationDetail>)}
      <Pagination
        name="pagination"
        perPage={pagination.per_page}
        perPageChanged={e => searchFunction(e.value)}
        total={pagination.total}
        page={pagination.page}
        prev={e => searchFunction(e.value)}
        next={e => searchFunction(e.value)}
      />
    </React.Fragment>
  )
}

function ShowSearchCondition(search) {
  let labels = []
  if (search.search_keywords) {
    labels.push(`キーワード: ${search.search_keywords}`)
  }
  if (search.search_hotel_ids && search.search_hotel_ids.length > 0) {
    let hotelLabel = `宿泊施設: ${search.search_hotel_ids.length} 施設`
    labels.push(hotelLabel)
  }
  if (search.search_start_date || search.search_end_date) {
    const start_date = search.search_start_date ? dateToStringDate(search.search_start_date) : ''
    const end_date = search.search_end_date ? dateToStringDate(search.search_end_date) : ''
    labels.push(`期間: ${start_date} ~ ${end_date}`)
  }
  if (search.search_status_booked || search.search_status_cancelled || search.search_status_not_a_reservation) {
    let statusLabel = 'ステータス: '
    let statusValues = []
    if (search.search_status_booked) {
      statusValues.push('予約済み')
    }
    if (search.search_status_cancelled) {
      statusValues.push('キャンセル')
    }
    if (search.search_status_not_a_reservation) {
      statusValues.push('売り止め')
    }
    const status = statusLabel + statusValues.join(', ')
    labels.push(status)
  }
  if (search.search_site_referrer_ids && search.search_site_referrer_ids.length > 0) {
    let referrerLabel = `流入元: ${search.search_site_referrer_ids.length} 件`
    labels.push(referrerLabel)
  }

  return (
    <MdcChipSet>
      {labels.map((label, index) => (
        <MdcChip id={index} label={label} />
      ))}
    </MdcChipSet>
  )
}

export default ReservationListView
